export default __webpack_public_path__ + "static/media/sexy_tshirt.2201e51c.jpg";